var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBarcode = function SvgBarcode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.253 12.963v5.639h5.64v1.254H.627a.627.627 0 0 1-.62-.534L0 19.229v-6.266h1.253zm18.269 0v6.266a.627.627 0 0 1-.534.62l-.093.007H12.63v-1.254h5.639v-5.64h1.254zM4.974 3.955V9.4h2.663V3.955H8.89V9.4h2.663V3.955h1.254L12.806 9.4h2.664V3.955h1.253V9.4h2.45v1.254h-2.45v5.638H15.47v-5.639h-2.664v5.64h-1.253v-5.64H8.89v5.64H7.637v-5.64H4.974v5.64H3.72l-.001-5.64H.627V9.4H3.72V3.955h1.254zM7.03 0v1.253H1.39v5.64H.139V.627c0-.315.232-.575.534-.62L.765 0h6.266zm12.003 0c.314 0 .575.232.62.534l.006.093v6.266h-1.253v-5.64h-5.64V0h6.267z"
  })));
};

export default SvgBarcode;